<template>
    
    <div class="searchContainer">
        <back title="成交估算"></back>
        <!-- <som-tabs class="tabView">
            <som-tab-item :selected="pageIndex===0" @on-item-click="onItemClick">免费估价</som-tab-item>
            <som-tab-item :selected="pageIndex===1" @on-item-click="onItemClick">精准定价</som-tab-item>
        </som-tabs> -->
        <div :class="['formBox',{'hideVin':!isShowVin}]">
            <p  class="formItem vin" @click="chooseVin">
                <i class="scan"></i>
                <i>扫描行驶证信息</i>
            </p>
            <p class="formItem" @click="chooseBrand">
                <span class="formLabel">品牌车型</span>
                <span v-if="modelName" class="model-name">{{ modelName }}</span>
                <input v-else type="text" placeholder="请选择" readonly="" :value="modelName">
                <i class="iconfont icon-jiantou right"></i>
            </p>
            <p class="formItem" @click="chooseCity">
                <span class="formLabel">车辆所在地</span>
                <input type="text" placeholder="请选择" readonly="" v-model="cityName">
                <i class="iconfont icon-jiantou right"></i>
            </p>
            <p class="formItem" @click="choosePicker('date')">
                <span class="formLabel">首次上牌</span>
                <input type="text" placeholder="请选择" placeholder-class="cc" readonly="" :value="licenseDate">
                <i class="iconfont icon-jiantou right"></i>
            </p>
            <p class="formItem">
                <span class="formLabel">行驶里程</span>
                <input type="number" class="mileage-box" placeholder="请填写  比如2.22" v-model="mileage" @blur="setMileage">
                <i class="right"><b>万公里</b></i>
            </p>
            <AccurateFormItem 
                              :dataList="carList"
                              :required="true"
                              :listIndex="1"
                              :chooseCondition="chooseCondition">
            </AccurateFormItem>
            <p class="formItem">
                <span class="formLabel">心理价</span>
                <input type="number" class="mileage-box" placeholder="请输入" v-model="psychologicalValue" @blur="setPsychological">
                <i class="right"><b>万元</b></i>
            </p>
      
        </div>

        <div class="w91" style="position: relative">
            <img v-if="!hasMargin && pageIndex === 1 && hasFirst && !showConditionPicker"
                 src="../../assets/img/mianfei.png" alt=""
                 class="tagImg">
            <sob-button class="theme cOrange w100 button hasIcon fs32 searchBtn"
                        @click="submit"
                        >
                        快速估算
            </sob-button>
            <!-- <div class="tagText" v-if="(token && !hasMargin) && pageIndex === 1">
                <p class="myButtonText">快速估算</p>
            </div> -->
        </div>

        <sob-toast v-model="isShowToast" :time="1000" is-show-mask position="middle" :text="toastMsg"></sob-toast>
        <sob-date-picker
            type="year-month"
            :min-date="new Date(1991, 0, 1)"
            :max-date="endDate"
            value-format="yyyy-MM"
            @on-confirm="licenseDatePicker"
            @on-cancel="cancelPicker"
            v-show="showDataPicker">
        </sob-date-picker>
        <sob-picker
            :columns="allData"
            show-toolbar
            value-key="dataDictValue"
            @on-confirm="colorPicker"
            @on-cancel="cancelPicker"
            v-show="showConditionPicker"
        />
        <sob-popup v-model="showConditionChoose" position="bottom" is-transparent max-height="70%">
            <chooseView :columns="allData"
                        :modalName="carList[itemIndex].label"
                        :onConfirm="colorPicker"
                        :onCancel="cancelPicker">
            </chooseView>
        </sob-popup>
        <c-monitor></c-monitor>
           
    </div>
</template>

<script>

import store from '../vuex/store';
import Tower, {towerController} from '@jarvis/tower-h5';
import cMonitor from "../common//c-monitor";
import back from "../common/back";
import AccurateFormItem from "./components/accurateFormItem";
import chooseView from "./components/chooseView";
import Luban from '../../lubanV2'
import {natureNameArr,score,accidentGrade} from './serve.js'
    import MD5 from '../../assets/js/md5'

    import * as http from '../../api/url'

const {appInfo} = towerController;
export default {
    store,
    name: "searchForm",
    data() {
        return {
            dialogShow:false,
            modelName: '',// 车型name
            modelCode: '', // 车型code
            modelYear: '', // 年份
            brandName: '', // 品牌
            brandCode: '', // 品牌code
            seriesCode: '', // 车系code
            cityName: '',//城市
            cityCode: '',//城市
            provinceCode: '', // 省份code
            licenseDate: '',//首次上牌时间
            mileage: '',//行驶里程
            psychologicalValue:'',//心理价
            color: '',//车身颜色
            residueDegree: -1,//剩余估价次数
            endDate: new Date(),
            startDate: this.$store.state.modelName ? new Date(Number(this.$store.state.modelName.substring(0, 4)) - 1, 0, 1) : new Date(1980, 0, 1),
            onlineId: "",
            allColor: [],//所有颜色
            state: {},
            score:'',
            scoreCode:'',
            accidentGrade:'',
            history: {},
            historyShow: false,
            tempFilePaths: "",
            isCleanForm: "",
            isShowToast: false,
            toastMsg: "",
            showDataPicker: false,
            showColorPicker: false,
            getCityValue: '',
            getElseValue: '',
            isShowVin: false,
            pageIndex: 0,
            showConditionPicker: false,
            showConditionChoose: false,
            carList: [
                {label: '使用性质', value:{
                    dataDictValue:'非运营'
                }, key: 'natureName', code: 'natureCode'},
                {label: '评分', value: '', key: 'score', code: 'scoreCode'},
                {label: '事故等级', value: '', key: 'accidentGrade', code: 'car_accident_grade'},
            ],
            natureName:'',
            routerType:null,
            score:'',
            accidentGrade:'',
            hasMargin: false, //是不是有押金
            hasFirst: false, //有没有第一次的免费体验机会
            // token: 'yizhihuan',
            token:this.$route.query.token,
            partnerId:this.$route.query.partnerId,
            shopCode:this.$route.query.shopCode,
            allData: [],
            listIndex: 0,
            itemIndex: 0,
            ispickcolor: false,
            seriesName: '',
            err:'',
        }
    },
    computed: {},
    watch: {
        mileage: function (val, oldval) {
            let mil = val.split(".");
            if (mil.length > 1 && mil[0].length == 0 && mil[1].length > 0) {
                this.mileage = 0 + "." + mil[1];
                return;
            }
            if (mil[0].length > 2) {
                mil[0] = mil[0].slice(0, 2);
                this.mileage = mil[0];
                return;
            }
            if (mil.length > 1 && mil[1].length > 2) {
                mil[1] = mil[1].slice(0, 2);
                this.mileage = mil[0] + "." + mil[1];
                return;
            }
            if (mil.length > 2) {
                this.mileage = mil[0] + "." + mil[1];
            }
        },
    },
    created() {
        this.headerFn();
        this.init();
    },
    activated() {
        setTimeout(()=>{
        this.headerFn();

        this.getLocalMessage();

        },0)
        if (this.$route.query.appKey === 'cheyipai') {
            Tower.nav.setSubRight({title: '历史', imageUrl: '', show: true});
        }
    },
    mounted() { //返回显示页面状态函数
        this.routerType=null;
        this.$store.commit('updateClientHeight', {
            clientHeight: $(document).height(),
        });
        if (this.$route.query.appKey === 'cheyipai') {
            this.checkUserData('init');
            Tower.nav.setSubRightBarListener(() => {
                Luban(this.$route.query, 'CJCYP_GJZS_GJJL', {});
                this.checkUserData('history')
            })
        } else {
            this.hasMargin = true
        }
        Luban(this.$route.query,'CJCYP_GJZS_PV');
    },
    components: {
        cMonitor,
        back,
        AccurateFormItem,
        chooseView
    },
    methods: {
    init(){
        this.headerFn();
        localStorage.removeItem('modelEvaluation')
        localStorage.removeItem('searchFormIndex')
        localStorage.removeItem('historyEvaluation')
        localStorage.removeItem('cityEvaluation')
        localStorage.removeItem('formElseMessage')
    },
        //处理用户次数逻辑
        checkUserData(type) {
            this.isLogin().then(token => {
                if (token) {
                    let api = '/cheyipai/evaluation/app/evaluationAppApi/getEvaluationNumAndDeposit.json';
                    this.getRequestData(api, {}, 'get').then(resData => {
                        this.hasMargin = Number(resData.deposit) >= 2000;
                        this.hasFirst = resData.num === 0;
                        switch (type) {
                            case 'onSubmit':
                                this.rexData();
                                break;
                            case 'history':
                                Tower.nav.setSubRight({title: '历史', imageUrl: '', show: false});
                                this.$router.push('/h5Web/evaluation_common/record')
                                break
                            case 'init':
                                this.token && Luban(this.$route.query,'CJCYP_GJZS_UV');
                                this.hasFirst && Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_MFQY_ZS');
                                this.hasMargin && Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_JZGJ_ZS');
                                break
                        }
                    })
                } else {
                    if (type !== 'init') {
                        Tower.invokeModule('cheyipai://loginopen/login', {}, (err, data) => {
                            if (err) console.log(err);
                            if (type === 'history') {
                                Tower.nav.setSubRight({title: '历史', imageUrl: '', show: false});
                                this.$router.push('/h5Web/evaluation_common/record')
                            }
                            if (type === 'onSubmit') {
                                this.rexData();
                            }
                        });
                    }
                }
            })
        },
        //处理所有筛选项数据请求
        loadDictData(code) {
                    this.showDataPicker=false;

                if ( code === 'natureNameCode') {
                    this.allData = this.natureNameArr
                    this.showConditionPicker = true
                }else if(code === 'natureCode'){
                    this.allData = natureNameArr.data.items;
                    this.showConditionPicker = true
                }else if(code ==='scoreCode'){
                    this.allData = score;
                    this.showConditionPicker = true

                }else if(code ==='car_accident_grade'){
                    this.allData = accidentGrade.data.items;
                    this.showConditionChoose = true
                }else {
                    this.allData = this.natureNameArr
                    this.showConditionPicker = true
                }
            // });
        },
        handleMsgAction() {
            this.hasFirst && Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_MFQY_DJ');
            this.hasMargin && Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_JZGJ_DJ');
            this.pageIndex = 1
        },
        onItemClick(index) {
            if (index === 0) {
                Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_TAB', {});
            } else {
                this.hasFirst && Luban(this.$route.query, 'CJCYP_GJZS_JZDJ_MFQY_ZS');
                !this.hasMargin && Luban(this.$route.query, 'CJCYP_GJZS_JZDJ_BZJ_ZS');
                Luban(this.$route.query, 'CJCYP_GJZS_JZDJ_TAB', {});
            }
            this.showConditionPicker = false
            this.pageIndex = index;
        },
        chooseCondition(data, listIndex, itemIndex) {
            this.loadDictData(data.code);
            this.listIndex = listIndex;
            this.itemIndex = itemIndex;
        },
        headerFn() {//头部
            document.title = '成交估算';
            // Tower.setWebViewTitle('估价助手');
        },
        getShowVin() {
            if (this.$route.query.appKey === 'cheniu') {
                this.isShowVin = false;
                return;
            }
            let ua = navigator.userAgent.toLowerCase();
            if (/android/i.test(ua) && this.$route.query.appKey !== 'yizhihuan') {
                this.isShowVin = this.$route.query.camera == 'on' ? true : false;
            } else {
                this.isShowVin = true;
            }
        },
        getParams() {
            return this.$route.query;
        },
        //获取接口信息列表(这个方法在页面加载以及点击查询时都会调用一次，点击查询时调用是因为有次数限制，校验真正的剩余次数)
        getRequestData(api, data, type,urlAll) {
            let me = this;
            me.$som.loading.show({
                text: '正在加载...',
            });
            return new Promise((resolve, reject) => {
            console.log(process.env)
                $.ajax({
                    dataType: "json",
                    type: type,
                    headers: {
                        'Souche-Inc-Security-Token': this.token,
                        'content-type': 'application/json'
                    },
                    data: type === 'post' ? JSON.stringify(data) : '',
                    // url: '/api/vehicle_auction_predict',
                    url:urlAll?api:process.env.CHENG_GU_URL + api,
                    // url: api,
                    success: function (res) {
                        me.$som.loading.hide()
                        resolve(res.data)
                    },
                    error: function (res) {
                        me.$som.loading.hide()
                        reject(res.data)
                        me.isShowToast = true;
                        me.toastMsg = "当前网络不可用，请检查网络设置";
                    }
                })
            })
        },
        //掉起选择器（颜色、上牌日期）
        choosePicker(type) {
                    this.showConditionPicker = false
            let me = this;
            if (type === "natureNameCode") {
                me.showConditionPicker = true;
                this.ispickcolor = true
                this.loadDictData('natureNameCode')
            } else if (type === "date") {
                me.showDataPicker = true;
            }
        },
        setSearchFormElseMessage(key, value) {
            const formElseMessage = JSON.parse(localStorage.getItem("formElseMessage"));
            const elseObj = {...formElseMessage, [key]: value};
            localStorage.setItem('formElseMessage', JSON.stringify(elseObj));
        },
        //点击选择器取消事件
        cancelPicker() {
            let me = this;
            me.showDataPicker = false;
            me.showConditionPicker = false;
            me.showConditionChoose = false
        },
        //首次上牌选择器确定
        licenseDatePicker(val) {
            var me = this;
            me.licenseDate = val;
            me.$store.commit('updateStartDate', {
                startDate: me.licenseDate,
            });
            me.setSearchFormElseMessage('licenseDate', val);
            me.showDataPicker = false;
        },
        //颜色选择器
        colorPicker: function (val, index) {
            console.log(val)
            if (this.ispickcolor) { //处理之前的免费的color逻辑
                this.showConditionPicker = false;
                this.color = val;
                this.ispickcolor = false;
                return
            }
            // if (this.listIndex === 0) { //必填项
            //     this.conditionList[this.itemIndex].value = val;
            // }
            if (this.listIndex === 1) { //
                this.carList[this.itemIndex].value = val;
                const formElseMessage = JSON.parse(localStorage.getItem("formElseMessage"));
                const keyCode=this.carList[this.itemIndex].code
                const elseObj = {...formElseMessage, [keyCode]:val.dataDictValue};
                localStorage.setItem('formElseMessage', JSON.stringify(elseObj));
            }
            this.showConditionPicker = false;
            this.showConditionChoose = false;
        },
        //选择VIN码识别
        chooseVin: function () {

            if (this.pageIndex === 0) {
                Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_CXSB');
            } else {
                Luban(this.$route.query, 'CJCYP_GJZS_JZDJ_CXSB');
            }

            //判断是否需求
            this.isLogin().then(token => {

                if (true) {
                this.$router.push({
                            path: '/h5Web/evaluation_common/getVinCode',
                            query: {userId: this.getParams().userId, pageIndex: this.pageIndex}
                });
                    // Tower.invokeModule('cheyipai://loginopen/login', {}, (err, data) => {
                    //     this.err=err
                    //     if (err) console.log(err);
                 
                    // });
                } else {
                    if (navigator.onLine) { //正常工作
                        localStorage.removeItem('imageStr');
                        localStorage.removeItem('imageUrl');
                        localStorage.removeItem('vinCode');
                        this.$router.push({
                            path: '/h5Web/evaluation_common/getVinCode',
                            query: {userId: this.getParams().userId}
                        });
                    } else {//执行离线状态时的任务
                        this.isShowToast = true;
                        this.toastMsg = "当前网络不可用，请检查网络设置";
                    }
                }
            })
        },
        //选择品牌
        chooseBrand: function () {
            if (navigator.onLine) { //正常工作
                this.$router.push({
                    path: '/h5Web/evaluation_common/BrandSelector',
                    query: {userId: this.getParams().userId, pageIndex: this.pageIndex}
                });
            } else {//执行离线状态时的任务
                this.isShowToast = true;
                this.toastMsg = "当前网络不可用，请检查网络设置";
            }
        },
        //选择城市
        chooseCity: function () {
            // if (navigator.onLine) { //正常工作
                this.$router.push({
                    path: '/h5Web/evaluation_common/CitySelector',
                    query: {userId: this.getParams().userId}
                });
            // } else {//执行离线状态时的任务
                // this.isShowToast = true;
                // this.toastMsg = "当前网络不可用，请检查网络设置";
            // }
        },
        //提交公里数到vuex
        setMileage: function () {
            this.$store.commit('updateMileage', {
                mileage: this.mileage,
            });
            this.setSearchFormElseMessage('mileage', this.mileage);
        },
                //提交公里数到vuex
        setPsychological: function () {
            this.$store.commit('updateMileage', {
                psychologicalValue: this.psychologicalValue,
            });
            this.setSearchFormElseMessage('psychologicalValue', this.psychologicalValue);
        },
        
        //查询按钮点击事件
        submit: function () {
            // if (navigator.onLine) { //正常工作
                if (this.pageIndex === 0) {
                    Luban(this.$route.query, 'CJCYP_GJZS_MFGJ_MFGJ');
                } else {
                    this.hasFirst && Luban(this.$route.query, 'CJCYP_GJZS_JZDJ_JZDJ_MF');
                    this.hasMargin && Luban(this.$route.query, 'CJCYP_GJZS_JZDJ_JZDJ');
                }
                var me = this;
                me.checkSubmitData();
            // } else {//执行离线状态时的任务
            //     this.isShowToast = true;
            //     this.toastMsg = "当前网络不可用，请检查网络设置";
            // }
        },
        checkSubmitData() {
                this.rexData()
        },
        //校验各字段是否为空
        rexData: async function () {
            var me = this;
            const natureName=me.carList[0].value;
            const score=me.carList[1].value;
            const accidentGrade=me.carList[2].value;
            if (me.modelName === "") {
                me.isShowToast = true;
                me.toastMsg = "请选择品牌";
                return;
            }
            if (me.licenseDate === "") {
                me.isShowToast = true;
                me.toastMsg = "请选择首次上牌时间";
                return;
            }
            if (me.mileage === "") {
                me.isShowToast = true;
                me.toastMsg = "请输入行驶里程";
                return;
            }
            let mil = me.mileage.split(".");
            if (Number(me.mileage) == 0) {
                me.isShowToast = true;
                me.toastMsg = "行驶里程不能为0";
                return;
            }
            if (Number(me.mileage) > 99) {
                me.isShowToast = true;
                me.toastMsg = "行驶里程不能超过99";
                return;
            }
            if (mil.length > 2) {
                me.isShowToast = true;
                me.toastMsg = "请输入正确的行驶里程";
                return;
            }
            if (mil.length > 1 && mil[1].length > 2) {
                me.isShowToast = true;
                me.toastMsg = "行驶里程可最多输入两位小数";
                return;
            }
            if (mil.length > 1 && mil[1] === 0) {
                mil.slice(0, 1);
                me.mileage = mil[0];
            }
            if (me.cityName === "") {
                me.isShowToast = true;
                me.toastMsg = "请选择车辆所在地";
                return;
            }
            
                if (natureName.dataDictValue === ""||(!natureName.dataDictValue)) {
                me.isShowToast = true;
                me.toastMsg = "请选择使用性质";
                return;
            }
            if (score.dataDictValue === ""||(!score.dataDictValue)) {
                me.isShowToast = true;
                me.toastMsg = "请选择评分";
                return;
            }
            if (accidentGrade.dataDictValue === ""||(!accidentGrade.dataDictValue)) {
                me.isShowToast = true;
                me.toastMsg = "请选择事故等级";
                return;
            }
            if (me.psychologicalValue === "") {
                me.isShowToast = true;
                me.toastMsg = "请填写心理价";
                return;
            }
                  const dataCar={
                    modelName: me.modelName,// 车型name
                    modelCode: me.modelCode, // 车型code
                    modelYear: me.modelYear, // 年份
                    brandName: me.brandName, // 品牌
                    brandCode: me.brandCode, // 品牌code
                    seriesCode: me.seriesCode, // 车系code
                    seriesName: me.seriesName, // 车系code
                    cityName: me.cityName,//城市
                    cityCode: me.cityCode,//城市
                    scoreCode:score.dataDictValue,
                    car_accident_grade:accidentGrade.dataDictValue,
                    provinceCode: me.provinceCode, // 省份code
                    licenseDate: me.licenseDate+'-01',//首次上牌时间
                    mileage: me.mileage,//行驶里程
                    psychologicalValue:Number(me.psychologicalValue),//心理价
                    natureCode:natureName.dataDictValue,
                    conditionName:score.dataDictValue+accidentGrade.dataDictValue,//车况
            }
             
            const res=await http.freeEvaluation({
                ...dataCar,
                appNo: "A2019070911",
                merchantNo: "M2019070911",
                carCondition: "good",
                // channelFlag: "EA91774E53E3291B0D08CE78363DE86B",
                channelSource: "yizhihuan",
                color: "0",
                productLineNo: "P2019070912",
                tabFlag: "good",
                uniqueValue: this.setDateTime(),
                userId: "",
           }, this.token,this.partnerId);
            const dealer=res.data&&res.data.dealer

            //  if (!dealer) {
            //     me.isShowToast = true;
            //     me.toastMsg = "freeEvaluation接口返回值无效";
            //     return;
            // }

            let parme = {
                seller_code:this.shopCode,
                car_feature_data:{
                    ...dataCar,
                    "dealer_buy_residual": dealer&&dealer.residual,
                     residualDown:dealer&&dealer.residualDown,
                     residualUp:dealer&&dealer.residualUp,
                }
            };

                this.carList.forEach(item => {
                    parme.car_feature_data[item.key] = item.value.dataDictValue;
                    
                })
            localStorage.setItem("searchFormIndex", JSON.stringify(parme));

            this.getRequestData('/api/trading_index', parme, 'post').then(res => {
                this.soucheSdk({
                    keyDetailId:0,
                    inParam:parme,
                    outParam:res
                });
         

            //路由
                this.$router.push({
                    path: '/h5Web/evaluation_common/searchResult',
                    query: {searchType: (this.pageIndex + 1).toString(),index:res}
                });
            });
    
        },
        
             setDateTime() {
                const appMinorVersion = navigator.appMinorVersion ? navigator.appMinorVersion : '';
                const str = this.randomRange(10) + new Date().getTime() + navigator.appCodeName + navigator.appName + navigator.appVersion + navigator.connection + navigator.mimeTypes + navigator.oscpu + navigator.platform + navigator.plugins + navigator.userAgent + appMinorVersion;
                const uniqueValue = str.MD5(32).toLocaleUpperCase();
                    return uniqueValue
            },
                    /*
            * 生成字母+数字的随机数
            * */
            randomRange(min, max) {
                let returnStr = "",
                    range = (max ? Math.round(Math.random() * (max-min)) + min : min),
                    charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for(let i=0; i<range; i++){
                    const index = Math.round(Math.random() * (charStr.length-1));
                    returnStr += charStr.substring(index,index+1);
                }
                return returnStr;
            },
        async   soucheSdk(data){
               await   http.buryingPoint( data,this.token,this.partnerId)
        },
        getLocalMessage() {
            const state = this.$store.state;
            const getCarValue = JSON.parse(localStorage.getItem('modelEvaluation'));
            const getCityValue = JSON.parse(localStorage.getItem('cityEvaluation'));
            
            const formElseMessage = JSON.parse(localStorage.getItem('formElseMessage'));
            this.modelName = state.modelName || getCarValue ? getCarValue.model.name : '';
            this.modelCode = state.modelCode || getCarValue ? getCarValue.model.code : '';
            this.modelYear = state.modelYear || getCarValue ? getCarValue.model.year : '';
            this.brandName = state.brandName || getCarValue ? getCarValue.brand.name : '';
            this.brandCode = state.brandCode || getCarValue ? getCarValue.brand.code : '';
            this.seriesCode = state.seriesCode || getCarValue ? getCarValue.series.code : '';
            this.seriesName = state.seriesName || getCarValue ? getCarValue.series.name : '';

            this.cityName = state.cityName || getCityValue ? getCityValue.cityName : '';
            this.cityCode = state.cityCode || getCityValue ? getCityValue.cityCode : '';
            this.provinceCode = state.provinceCode || getCityValue ? getCityValue.provinceCode : '';
            
            this.licenseDate = (formElseMessage&&formElseMessage.licenseDate) ? formElseMessage.licenseDate : this.modelYear?this.modelYear+'-01':'';
            
            this.mileage = state.mileage || formElseMessage && formElseMessage.mileage ? formElseMessage.mileage : '';
            this.psychologicalValue = state.psychologicalValue || formElseMessage && formElseMessage.psychologicalValue ? formElseMessage.psychologicalValue : '';
            this.natureName = state.natureName || formElseMessage && formElseMessage.natureName ? formElseMessage.natureName : '';
            this.score = state.score || formElseMessage && formElseMessage.score ? formElseMessage.score : '';
            this.accidentGrade = state.accidentGrade || formElseMessage && formElseMessage.accidentGrade ? formElseMessage.accidentGrade : '';
            
            this.color = state.color || formElseMessage && formElseMessage.color ? formElseMessage.color : '';
            this.startDate = this.modelName ? new Date(Number(this.modelName.substring(0, 4)) - 1, 0, 1) : new Date(1980, 0, 1);
            for(let v of this.carList){
                if(formElseMessage&&formElseMessage[v.code]){
                    v.value={};
                    v.value.dataDictValue=formElseMessage[v.code]
                }else{
                    if(!(v.key==='natureName')){
                        v.value=''
                    }else{
                    v.value={
                                dataDictValue:'非运营'
                            }
                    }
                }
            }

        },
        isLogin() {
            if (this.$route.query.appKey !== 'cheyipai') {
                return new Promise((resolve => {
                    resolve(this.$route.query.appKey)
                }))
            }
            return new Promise((resolve) => {
                try {
                    Tower.invokeModule(
                        `${appInfo.su_AppScheme}://getAppDataInfo/cypAppDataInfo`,
                        {},
                        (err, res) => {
                            if (err) {
                                this.$som.toast.show({text: err});
                                return;
                            }
                            this.token = res['Souche-Inc-Security-Token'];
                            resolve(res['Souche-Inc-Security-Token']);
                        }
                    );
                } catch (e) {
                    this.$som.toast.show({text: e});
                }
            });
        }
    },
    destroyed() {
        Tower.nav.removeSubRightBarListener()
    }
}
</script>

<style type="text/css">
@import "../../assets/fonts/iconfont.css";

#app, html, body {
    height: 100%;
}

.searchContainer {
    height: 100%;
    max-width: 100%;
    overflow-x: hidden;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*align-items: center;*/
    /*justify-content: flex-start;*/
    box-sizing: border-box;
    background-color: white;
    overflow: scroll;
}

.m32 {
    margin: 0.16rem;
}

.w100 {
    width: 100%;
}

.w91 {
    width: calc(100% - 0.3rem);
    margin: 0 auto;
    /*padding-top: 0.15rem;*/
}

.h120 {
    height: 0.6rem;
}

.fs32 {
    font-size: 0.16rem;
}

.button {
    border: solid 0.005rem transparent;
}

.button.cBlue {
    background-color: #538EEB;
    color: #fff;
}

.button.cOrange, .button.cOrange:active {
    background-color: #FF571A;
    color: #fff;
}

.button.hasIcon .iconfont {
    display: inline-block;
    margin-right: 0.12rem;
    font-size: 0.2rem;
}

.formBox {
    /*width: calc(100% - 0.3rem);*/
    padding-top: 0.2rem;
    background-color: white;
}

.formBox.hideVin {
    /*padding: 0.1rem 0.15rem 0 0.15rem;*/
}

.formBox .formItem {
    height: 0.5rem;
    line-height: 0.53rem;
    border-bottom: solid 0.005rem #E7E7E7;
    position: relative;
    margin: 0 0.15rem;
}

.formBox .formItem.vin {
    height: 0.45rem;
    padding-bottom: 0.19rem;
    line-height: 0.45rem;
    /* border: 1px dashed #FF571A; */
    border-radius: 0.05rem;
    color: #FF571A;
    text-align: center;
    font-size: 0.15rem;
    margin-bottom: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: #FFF8F6; */
}

.formBox .formItem.vin input {
    height: 0.45rem;
    line-height: 0.45rem;
    width: 100%;
    opacity: 0;
    right: 0;
}

.formBox .formItem.vin .scan {
    display: inline-block;
    width: 0.15rem;
    height: 0.15rem;
    background: url("../../assets/img/scan.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 0.1rem;
}

.formBox .formItem .formLabel {
    display: inline-block;
    flex-shrink: 0;
    width: 1.05rem;
    margin-right: 0.16rem;
    font-size: 0.16rem;
    font-weight: normal;
    color: #000000;
}

.formBox .formItem .model-name {
    color: #000;
    font-size: 0.16rem;
    line-height: 0.24rem;
    width: 65%;
    text-align: right;
    text-align: -webkit-right;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-inline-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    -webkit-line-clamp: 2;
    position: absolute;
    top: 50%;
    right: 0.2rem;
    transform: translate(0, -50%);

}

.formBox .must {
    color: #FF710D;
    display: inline-block;
}

.formBox input {
    height: 0.53rem;
    /*line-height: 0.53rem;*/
    font-size: 0.16rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    right: 0.2rem;
    text-align: right;
    color: #1a1a1a;
}

.formBox input.mileage-box {
    right: 0.6rem;
}

.cc {
    color: #B0B1B8;
}

.formBox .formValue {
    color: #ccc;
    font-size: 0.15rem;
    width: 60%;
}

.formBox .right {
    min-width: 0.1rem;
    font-size: 0.16rem;
    color: #000;
    text-align: right;
    flex-shrink: 0;
    box-sizing: border-box;
    position: absolute;
    right: 0;
}

.formBox .right b {
    font-weight: normal;
}

.formBox .right.iconfont {
    font-size: 0.15rem;
    color: #aaa;
}

.formBox input.mwid {
    flex: 1;
    padding-left: 10rem;
}

.formBox .sWid {
    width: 0;
}

.botBtn {
    height: 0.53rem;
    line-height: 0.53rem;
    border-radius: 0;
    position: fixed;
    bottom: 0;
    left: 0;
}

input {
    background: transparent;
    border: none;
}

::-webkit-input-placeholder {
    color: #ccc;
}

.camBtn {
    height: 0.6rem;
    line-height: 0.6rem;
    font-weight: bold;
    border: solid 0.005rem #FF710D;
    margin-top: 0.06rem;
    border-radius: 0.04rem;
}

.searchBtn {
    height: 0.45rem;
    line-height: 0.45rem;
    width: 100%;
    text-align: center;
    border-radius: 0.22rem;
    background: linear-gradient(90deg, #FF7519 1%, #FE5619 100%);
    margin-top: 0.32rem;
    margin-bottom: 0.18rem
}

.searchBtn.disable {
    background: #D5DCE8;
}

.degreeTips {
    text-align: center;
    color: #999;
    font-size: 0.13rem;
    margin-top: 0.16rem;
}

.degreeNum {
    color: #FF710D;
}

.choosePicker {
    position: absolute;
    display: block;
    width: 3.75rem;
    height: 0.53rem;
    left: 0;
    top: 0;
    opacity: 0;
    background: #e3f;
    z-index: 3;
}

.history {
    display: flex;
    flex-direction: column;
}

.history.hide {
    display: none;
}

.history h4 {
    height: 0.8rem;
    line-height: 0.8rem;
    background: #F6F7F9;
    color: #999;
    font-size: 0.28rem;
    width: 100%;
}

.history h4 span {
    padding-left: 4.5%;
}

.history dl {
    background: #fff;
    height: 1.44rem;
    position: relative;
    border-bottom: solid 0.005rem #D9D9D9;
}

.history dt {
    color: #1a1a1a;
    font-size: 0.32rem;
    height: 0.32rem;
    line-height: 0.32rem;
    margin-top: 0.32rem;
    padding-left: 4.5%;
    margin-bottom: 0.2rem;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.history dd {
    padding-left: 4.5%;
}

.history dd {
    color: #999;
    font-size: 0.28rem;
    line-height: 0.28rem;
}

.history dl i {
    position: absolute;
    right: 4.5%;
    top: 0.6rem;
    font-size: 0.16rem;
    color: #666;
}

.sob-picker, .sob-date-picker {
    width: 100%;
    position: fixed;
    bottom: 0;
}

.sob-toast__wrap.sob-toast-middle {
    top: 30%;
    transform: translateX(-50%) translateY(0%);
}

.messageView {
    display: flex;
    align-content: center;
    justify-content: space-around;
    margin: 0 auto;
    background-color: #FFF0EB;
    padding: 0.1rem 0.05rem;
    border-radius: 8px;
    width: calc(100% - 0.4rem);
    color: #373737;
    font-size: 0.13rem;
    /*margin: 0 auto;*/
}

.messageButton {
    height: 0.28rem;
    border-radius: 20px;
    border: 1px solid #FF571A;
    padding: 0px 0.15rem;
    line-height: 0.28rem;
    font-size: 0.13rem;
    margin: auto 0;
    color: #FF571A;
}

.messageImg {
    width: 0.35rem;
    height: 0.35rem;
    margin: auto;
}

.messageText {
    font-size: 0.13rem;
    margin: auto;
    margin-left: 10px;
}

.tagImg {
    position: absolute;
    width: 0.5rem;
    right: 0.85rem;
    z-index: 200;
    top: 0.07rem
}

.tagText {
    position: absolute;
    font-size: 0.12rem;
    top: -0.1rem;
    text-align: center;
    width: 100%;
    margin-top: 20px;
    pointer-events: none;
}

.isHasMargin {
    height: 0.60rem;
    border-radius: 0.4rem;
}

.myButtonText {
    color: white;
    font-size: 16px;
    font-weight: 500;
}

.myButtonSubText {
    color: white;
    font-size: 12px;
    margin-top: 2px;
}

.tabView {
    width: 100vw;
    background-color: white;
    z-index: 2000;
}
</style>



// WEBPACK FOOTER //
// src/components/searchForm/searchForm.vue